import { Contact } from "./contact.model";

export class ContactsSegment {
    constructor(
        public contacts: Contact[] = [],
        public totalContactsCount: number = 0
    ) { }
}